<template>
  <div class="review-section" >

    <div class="flex flex-between">
      <img src="/images/reviews-logo.png" alt="Habit Health: Google Reviews">
      <a class="button small" :href="businessUrl" target="_blank">Write a review</a>
    </div>

    <div class="review-count">
      <p v-if="hasReview">{{ rating }}</p>
      <div class="stars" v-if="hasReview">
        <img src="/images/reviews-stars.png" alt="Habit Health: Google Reviews">
      </div>
      <p class="reviews" v-if="hasReview">{{ reviews }} reviews</p>
    </div>

  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
export default {
  props: {
    placeurl: String,
    placeid: String,
    mykey: String,
    url: String,
  },
  data () {
    return {
      hasReview: false,
      map: null,
      rating: 0,
      reviews: 0,
      businessUrl: '#'
    };
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    getData () {
        axios.get(this.url)
          .then((response) => {
              console.log('response', response)
            if (response.data.status === "OK") {
                this.hasReview = response.data.result.rating && response.data.result.rating > 0 ? true : false
                this.rating = response.data.result.rating
                this.reviews = response.data.result.user_ratings_total
                this.businessUrl = response.data.result.url
            }
          })
          .catch((error) => {
            if (error.response.status == 422) {
              this.errors = error.response.data.errors
            } else {
              this.fail_msg = 'Something went wrong. Please try again.'
            }
          })
          .then((res) => {
            this.isDisabled = false
          })
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../sass/core/variables.scss";

.review-section {
  margin-bottom: 20px;
  padding: 19px;
  border: 1px solid #d7e0e7;

  @media (min-width: $mediumish) {
    padding: 19px;
  }

  .flex {
    margin-bottom: 23px;
  }

  .button {
    width: 150px;
  }

  .review-count {
    p {
      display: inline-block;
      width: auto;
      margin: 0 7px 0 0;

      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      color: #3f4142;
    }

    .stars {
      display: inline-block;
      width: 82px;
      margin: 0 10px 0 0;

      img {
        width: 82px;
      }
    }

    p.reviews {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      color: #657781;
    }
  }
}
</style>




// WEBPACK FOOTER //
// resources/assets/frontend/js/components/GoogleReview.vue